<template>
  <div>
    <Header v-if="company && company.id" :companyId="companyId"></Header>

    <b-modal
      ref="quickEdit"
      title="Company Quick Add/Edit"
      ok-title="Save Company Record"
      size="xl"
      @ok="onSaveCompanyRecord"
    >
      <quick-edit ref="editModal" :companyId="companyId" :updateCompany="saveCompanyRecord"></quick-edit>
    </b-modal>

    <!-- Contacts MODAL  -->
    <b-modal
      ref="addEditContactModal"
      title="Add Contact"
      ok-title="Save Company Contact"
      size="xl"
      @ok="onSaveCompanyContactRecord"
    >
      <contact-form
        ref="contactForm"
        :company-id="companyId"
        :contact="{}"
        :update-company-contact="saveCompanyContactRecord"
        :contact-role-types="contactRoleTypes"
      ></contact-form>
    </b-modal>

    <!-- Locations MODAL  -->
    <b-modal
      ref="addEditLocationModal"
      title="Add Location"
      ok-title="Save Company Location"
      size="xl"
      @ok="onSaveCompanyLocationRecord"
    >
      <location-form
        ref="locationForm"
        :company-id="companyId"
        :company="{}"
        :update-company-location="saveCompanyLocationRecord"
      ></location-form>
    </b-modal>

    <div class="d-flex justify-content-between menu-margin">
      <div class="d-flex ml-2">
        <b-button size="sm" class="mr-2 button-menu" @click="showAddEditContactModal">
          <i class="fa fa-address-card mr-2"></i>Add Contact
        </b-button>
        <b-button size="sm" class="mr-2 button-menu" @click="showAddEditLocationModal">
          <i class="fa fa-map-marker mr-2"></i>Add Location
        </b-button>
        <b-button size="sm" class="mr-2 button-menu" @click="newClientCaseClick">
          <i class="fa fa-comment mr-2"></i>New Client Case
        </b-button>
      </div>
      <div class="d-flex mr-2">
        <b-button size="sm" class="mr-2 button-menu" @click="showQuickAddEditModal">
          <i class="fa fa-edit mr-2"></i>Quick Edit
        </b-button>
        <b-button
          id="verify"
          size="sm"
          class="mr-2 button-menu"
          v-if="!company.isVerified"
          @click="verifyClick"
        >
          <i class="fa fa-check mr-2"></i>Verify
        </b-button>
        <div style="color:white; font-size:20px; display: flex; align-self: center" id="label"></div>
      </div>
    </div>
    <b-card no-body class="rounded-0 mb-0">
      <b-tabs card active-nav-item-class="font-weight-bold border-top">
        <b-tab title="Cases" active>
          <details-tab :companyId="companyId" />
        </b-tab>
        <b-tab title="Locations">
          <location-tab :companyId="companyId" />
        </b-tab>
        <b-tab title="Business Units">
          <business-units-tab :companyId="companyId" />
        </b-tab>
        <b-tab title="Contacts">
          <contact-tab :companyId="companyId" />
        </b-tab>
        <b-tab title="Corporate">
          <corporate-tab />
        </b-tab>
        <b-tab title="Standard Documents">
          <standard-documents-tab :companyId="companyId" />
        </b-tab>
        <b-tab title="Files">
          <file-tab :companyId="companyId" />
        </b-tab>
        <b-tab title="Notifications">
          <b-card-text>Tab Contents 2</b-card-text>
        </b-tab>
        <b-tab title="History">
          <b-card-text>Tab Contents 2</b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DetailsTab from './Tabs/Details';
import LocationTab from './Tabs/Location';
import BusinessUnitsTab from './Tabs/BusinessUnits';
import CorporateTab from './Tabs/Corporate';
import ContactTab from './Tabs/Contact';
import StandardDocumentsTab from './Tabs/StandardDocuments';
import FileTab from './Tabs/File';
import Header from './components/Header';
import QuickEdit from './components/QuickEdit';
import ContactForm from './Tabs/Contact/Form';
import LocationForm from './Tabs/Location/Form';

import StarRating from 'vue-star-rating';

export default {
  components: {
    Header,
    QuickEdit,
    StarRating,
    DetailsTab,
    LocationTab,
    BusinessUnitsTab,
    CorporateTab,
    ContactTab,
    StandardDocumentsTab,
    FileTab,
    ContactForm,
    LocationForm
  },
  metaInfo: function() {
    return {
      title: ''
    };
  },
  data() {
    return {
      showQuickEdit: false,
      saveCompanyRecord: false,
      saveCompanyContactRecord: false,
      saveCompanyLocationRecord: false,
      emptyObj: {},
      emptyContact: {}
    };
  },
  computed: {
    ...mapState('companies', ['company']),
    ...mapState('contacts', ['contactRoleTypes']),
    ...mapGetters('companies', ['companyById']),
    /*company() {
        let company = this.companyById(this.companyId);
        return this.companyById(this.companyId);
      },*/
    companyId() {
      return this.$route.params.id;
    }
  },
  watch: {
    companyId() {
      this.getById(this.companyId);
    }
  },
  methods: {
    ...mapActions('companies', ['getById', 'verifyCompany']),
    onSaveCompanyRecord(event) {
      event.preventDefault();
      this.$refs.editModal.$v.$touch();
      if (this.$refs.editModal.$v.$invalid) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.quickEdit.hide();
      });
      this.saveCompanyRecord = Date.now();
    },
    showQuickAddEditModal() {
      this.$refs['quickEdit'].show();
    },
    showAddEditContactModal() {
      this.$refs['addEditContactModal'].show();
    },
    showAddEditLocationModal() {
      this.$refs['addEditLocationModal'].show();
    },
    addContactClick() {
      this.$bvModal.msgBoxOk('Add Contact');
    },
    uploadFileClick() {
      this.$bvModal.msgBoxOk('Add Upload File');
    },
    addLocationClick() {
      this.$bvModal.msgBoxOk('Add Location');
    },
    newClientCaseClick() {
      this.$bvModal.msgBoxOk('Add Client Case');
    },
    verifyClick() {
      //TODO: Add security for those who have permission
      this.$bvModal
        .msgBoxConfirm('Verfiy the Company?')
        .then(ok => {
          if (ok) {
            var date = new Date();
            var today = `${this.getDateNumber(
              date.getDate()
            )}/${this.getDateNumber(
              date.getMonth() + 1
            )}/${date.getFullYear()}`;
            // this.verifyCompany(this.companyId);
            document.getElementById('verify').remove();
            document.getElementById('label').innerHTML = 'Verified:' + today;
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    onSaveCompanyContactRecord(event) {
      event.preventDefault();
      this.$refs.contactForm.$v.$touch();
      if (this.$refs.contactForm.$v.$invalid) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.addEditContactModal.hide();
      });
      this.saveCompanyContactRecord = Date.now();
    },
    onSaveCompanyLocationRecord(event) {
      event.preventDefault();
      this.$refs.locationForm.$v.$touch();
      if (this.$refs.locationForm.$v.$invalid) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.addEditLocationModal.hide();
      });
      this.saveCompanyLocationRecord = Date.now();
    },
    getDateNumber(number) {
      if (number < 10) {
        return `0${number}`;
      }
      return number;
    }
  },
  async mounted() {
    await this.getById(this.companyId);
  }
};
</script>

<style scoped>
#company-details-header {
  background: #eee;
}

.button-menu {
  font-weight: 600 !important;
  letter-spacing: 0.1em;
  background-color: #66cccc;
  text-transform: uppercase;
}

.menu-margin {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
